@if (isLoading) {
  <div class="loading">
    <div class="loading_txt">
      <div class="load_txt">{{"financialDashboard.loadinglabel" | cxTranslate}}</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
@if (showCreditSection) {
  <section class="col-xs-12 col-sm-12 credits_invoices forUKReturns credits_UK">
    <div class="clearboth"></div>
    <div class="credits_credit">
      <div class="col-xs-12 col-sm-12 credits_headerparent no-padding">
        <div class="col-xs-12 col-sm-12 no-padding credits_invoiceheader">{{"financialDashboard.creditinfotxt" | cxTranslate}}</div>
      </div>
      <div class="col-xs-12 col-sm-12 credits_invoicebtns">
        <div class="col-xs-12 col-sm-4 credits_creditbtn active" id="credits_creditbtn-1" (click)="opencredit(1)">
          <div class="credits_invoicebtnheader">{{"financialDashboard.availablecredit" | cxTranslate}}</div>
        </div>
        <div class="col-xs-12 col-sm-4 credits_creditbtn" id="credits_creditbtn-2" (click)="opencredit(2)">
          <div class="credits_invoicebtnheader">{{"financialDashboard.creditsprocessing" | cxTranslate}}</div>
        </div>
        <!-- refund new tab added -->
        <div class="col-xs-12 col-sm-4 credits_creditbtn" id="credits_creditbtn-3"(click)="opencredit(3)">
          <div class="credits_invoicebtnheader">{{"financialDashboard.creditapplied" | cxTranslate}}</div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 credits_credittable open" id="credits_credittable1">
        <!-- new refund code -->
        <div class="credits_creditheaderParent">
          <div class="credits_creditheader">
            <div class="credits_leftHeader">
              <div class="credits_creditheaderText">
                {{"financialDashboard.totalavailablecredit" | cxTranslate}}
                <span class="credits_creditavail">{{financialresponse?.seqirusFinancialDashboardData?.credit.totalAvailableCredit | currency:'GBP':'symbol':'1.2-2'}}</span>
              </div>
              <div class="credits_creditheaderTooltip" id="credits_creditheaderTooltip-1">
                {{ukCreditsContent.content}}
                <span [innerHTML]="ukCreditsContent.link" appRouterlinkinterceptor></span>
              </div>
            </div>
            @if (financialresponse?.isRefundWindowOpen && financialresponse?.userEligibleForApplyRefund && isAsmUser && rbavalue?.hasManageFin==true) {
              <button class="refundRequest" (click)="openRefund()">Request a Refund</button>
            } @else {
              <div class="helpParent" appRouterlinkinterceptor [innerHTML]="'financialDashboard.needhelptxt' | cxTranslate">
              </div>
            }
          </div>
        </div>
        <div class="credits_creditabledetail1">
          <table id="credits_creditavailTable-1" [ngClass]="creditavailable?.data?.length==0?'emptyTable':''" class="credits_Tablecredit d-none d-md-block d-lg-block" mat-table [dataSource]="creditavailable">
            <ng-container matColumnDef="creditNote">
              <th mat-header-cell *matHeaderCellDef class="creditWhiteSpace">
                {{"financialDashboard.credit_Note_heading" | cxTranslate}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.invoiceNumber}} </td>
            </ng-container>
            <ng-container matColumnDef="creditAmount">
              <th mat-header-cell *matHeaderCellDef class="creditWhiteSpace">{{"financialDashboard.credit_Amount_heading" | cxTranslate}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.amoutWithTax | currency:'GBP':'symbol':'1.2-2'}}  </td>
            </ng-container>
            <ng-container matColumnDef="issuedDate">
              <th mat-header-cell *matHeaderCellDef>
                {{"financialDashboard.date_issue_heading" | cxTranslate}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.invoiceDate}} </td>
            </ng-container>
            <ng-container matColumnDef="viewCredit">
              <th mat-header-cell *matHeaderCellDef>
              </th>
              <td mat-cell *matCellDef="let element">
                <a class="anchorlink" (click)="financialgetDownloadInvoiceData(element.invoiceNumber)"><span class="anchorunderline">{{"financialDashboard.viewcreditnoteuk" | cxTranslate}}</span><div class="global_blackarrow"></div></a>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="creditcolumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: creditcolumns;"></tr>
          </table>
        <!-- </div> -->
      </div>
      <div class="credits_creditavailMobiletable-1"></div>
    </div>
    @if (showfootnote && financialresponse?.isRefundWindowOpen && financialresponse?.userEligibleForApplyRefund && isAsmUser) {
      <div class="col-xs-12 credits_footnote">{{ukCreditsContent.refundText}} <a [href]="getPdfUrl(ukCreditsContent.privacyLink)" target="_blank">privacy policy</a>.</div>
    }
    <div class="col-xs-12 col-sm-12 credits_credittable" id="credits_credittable2">
      <div class="credits_creditheaderParent">
        <div class="credits_creditheader">
          <div class="credits_leftHeader">
            <div class="credits_creditheaderText">{{"financialDashboard.totalprocessingcredit" | cxTranslate}}<span class="credits_creditprocessed">{{financialresponse?.seqirusFinancialDashboardData?.credit.totatProcessingCredit | currency:'GBP':'symbol':'1.2-2'}}</span>
            <!-- add count of processed -->
          </div>
          <div class="credits_creditheaderTooltip" id="credits_creditheaderTooltip-2">
            {{ukCreditsContent.content}}
            <span [innerHTML]="ukCreditsContent.link"></span>
          </div>
        </div>
        <div class="helpParent" appRouterlinkinterceptor [innerHTML]="'financialDashboard.needhelptxt' | cxTranslate">
        </div>
      </div>
    </div>
    <div class="credits_creditabledetail1">
      <table id="credits_creditprocessedTable-1" [ngClass]="creditpending.data.length==0?'emptyTable':''" class="credits_Tablecredit d-none d-md-block d-lg-block" mat-table [dataSource]="creditpending">
        <ng-container matColumnDef="creditNote">
          <th mat-header-cell *matHeaderCellDef class="creditWhiteSpace">
            {{"financialDashboard.credit_Note_heading" | cxTranslate}}
          </th>
          <td mat-cell *matCellDef="let element"> {{element.invoiceNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="creditAmount">
          <th mat-header-cell *matHeaderCellDef class="creditWhiteSpace">{{"financialDashboard.credit_Amount_heading" | cxTranslate}}
          </th>
          <td mat-cell *matCellDef="let element"> {{element.amoutWithTax | currency:'GBP':'symbol':'1.2-2'}} </td>
        </ng-container>
        <ng-container matColumnDef="issuedDate">
          <th mat-header-cell *matHeaderCellDef>
            {{"financialDashboard.date_issue_heading" | cxTranslate}}
          </th>
          <td mat-cell *matCellDef="let element"> {{element.invoiceDate}} </td>
        </ng-container>
        <ng-container matColumnDef="viewCredit">
          <th mat-header-cell *matHeaderCellDef>
          </th>
          <td mat-cell *matCellDef="let element">
            <a class="anchorlink" (click)="financialgetDownloadInvoiceData(element.invoiceNumber)"><span class="anchorunderline">{{"financialDashboard.viewcreditnoteuk" | cxTranslate}}</span><div class="global_blackarrow"></div></a>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="creditcolumns;"></tr>
        <tr mat-row *matRowDef="let row; columns: creditcolumns;"></tr>
      </table>
    </div>
    <div class="credits_creditprocessedMobiletable-1"></div>
  </div>
  <div class="col-xs-12 col-sm-12 credits_credittable" id="credits_credittable3">
    <div class="credits_creditheaderParent">
      <div class="credits_creditheader">
        <div class="credits_leftHeader">
          <div class="credits_creditheaderText">
            {{"financialDashboard.totalcreditapplied" | cxTranslate}}
            <span class="credits_creditused">{{financialresponse?.seqirusFinancialDashboardData?.credit.totalUsedCredit | currency:'GBP':'symbol':'1.2-2'}}</span>
          </div>
          <div class="credits_creditheaderTooltip" id="credits_creditheaderTooltip-2">
            {{ukCreditsContent.content}}
            <span [innerHTML]="ukCreditsContent.link"></span>
          </div>
        </div>
        <div class="helpParent" appRouterlinkinterceptor><div class="helpHeader">Need Help?</div><div class="helpsubHeader">Contact&nbsp; <a href="/contact-us">flu360 | Support</a></div>
      </div>
    </div>
  </div>
  <div class="credits_creditabledetail1">
    <table id="credits_crediappliedTable-1" [ngClass]="creditapplied.data.length==0?'emptyTable':''" class="credits_Tablecredit d-none d-md-block d-lg-block" mat-table [dataSource]="creditapplied">
      <ng-container matColumnDef="creditNote">
        <th mat-header-cell *matHeaderCellDef class="creditWhiteSpace">
          {{"financialDashboard.credit_Note_heading" | cxTranslate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.invoiceNumber}} </td>
      </ng-container>
      <ng-container matColumnDef="creditAmount">
        <th mat-header-cell *matHeaderCellDef class="creditWhiteSpace">{{"financialDashboard.credit_Amount_heading" | cxTranslate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.amoutWithTax | currency:'GBP':'symbol':'1.2-2'}} </td>
      </ng-container>
      <ng-container matColumnDef="issuedDate">
        <th mat-header-cell *matHeaderCellDef>
          {{"financialDashboard.date_issue_heading" | cxTranslate}}
        </th>
        <td mat-cell *matCellDef="let element"> {{element.invoiceDate}} </td>
      </ng-container>
      <ng-container matColumnDef="viewCredit">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let element">
          <a class="anchorlink" (click)="financialgetDownloadInvoiceData(element.invoiceNumber)"><span class="anchorunderline">{{"financialDashboard.viewcreditnoteuk" | cxTranslate}}</span><div class="global_blackarrow"></div></a>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="creditcolumns;"></tr>
      <tr mat-row *matRowDef="let row; columns: creditcolumns;"></tr>
    </table>
  </div>
  <div class="credits_creditappliedMobiletable-1"></div>
</div>
</div>
<div class="clearboth"></div>
</section>
}

<!-- refund section -->
@if (showRefundSection) {
  <section class="col-xs-12 col-sm-12 credits_refund credits_UK">
    <div class="col-xs-12 col-sm-12 no-padding credits_refundheader">{{"financialDashboard.newcreditrefundtxt" | cxTranslate}}</div>
    <!-- new bank details page starts -->
    @if (showEditForm) {
      <div class="col-xs-12 refund_newBankData">
        <div class="refund_dataWrapper col-xs-11">
          <div class="refund_text1">{{"financialDashboard.bankdetails" | cxTranslate}}</div>
          <div class="refund_text2">{{"financialDashboard.bankdetailserror" | cxTranslate}}</div>
          <form id="refundBankDetails" [formGroup]="refundCreditsForm">
            <!-- <c:choose>
            <c:when test="${bankDetails.payerbankAccountNumber eq 'null' || empty bankDetails.payerbankAccountNumber}">
              <input type="hidden" value="new" name="requestType" class="refundRequestType">
              </c:when>
              <c:otherwise>
                <input type="hidden" value="verified" name="requestType" class="refundRequestType">
                </c:otherwise>
                </c:choose> -->
                <div class="col-xs-12 border_box no-left-pad">
                  <div class="col-xs-4 inputParent" [ngClass]="{'has-error':refundCreditsForm.get('bankAccName')?.touched && refundCreditsForm.get('bankAccName')?.invalid}">
                    <label class="input_parentlabel">{{"financialDashboard.accname" | cxTranslate}}*</label>
                    <label class="input_sublabel">{{"financialDashboard.fullbusinessname" | cxTranslate}}</label>
                    <input type="text" name="bankAccName" class="bankAccName form-control" formControlName="bankAccName" autocomplete="off"/>
                    @if (refundCreditsForm.get('bankAccName')?.touched && refundCreditsForm.get('bankAccName')?.invalid) {
                      <span class="glyphicon form-control-feedback glyphicon-exclamation-sign"></span>
                    }
                    @if (refundCreditsForm.get('bankAccName')?.touched && refundCreditsForm.get('bankAccName')?.invalid) {
                      <label id="bankAccName-error" class="error help-block" for="bankAccName">{{"financialDashboard.accnameerror" | cxTranslate}}</label>
                    }
                  </div>
                  <div class="col-xs-4 inputParent" [ngClass]="{'has-error':refundCreditsForm.get('bankAccNo')?.touched && refundCreditsForm.get('bankAccNo')?.invalid}">
                    <label>{{"financialDashboard.bankaccno" | cxTranslate}}*</label>
                    <label class="input_sublabel"></label>
                    <input type="text" name="bankAccNo" id="accountNumber" class="bankAccNo form-control starfunction" maxlength="8" formControlName="bankAccNo" autocomplete="off"/>
                    @if (refundCreditsForm.get('bankAccNo')?.touched && refundCreditsForm.get('bankAccNo')?.invalid) {
                      <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                    }
                    @if (refundCreditsForm.get('bankAccNo')?.touched && refundCreditsForm.get('bankAccNo')?.invalid) {
                      <label id="accountNumber-error" class="error help-block" for="accountNumber">{{"financialDashboard.accnoerror" | cxTranslate}}</label>
                    }
                  </div>
                  <div class="col-xs-2 inputParent" [ngClass]="{'has-error':refundCreditsForm.get('sortCode')?.touched && refundCreditsForm.get('sortCode')?.invalid}">
                    <label>{{"financialDashboard.sortcode" | cxTranslate}}*</label>
                    <label class="input_sublabel"></label>
                    <input type="text" name="sortCode" id="sortCode" class="bankSortNo form-control starfunction" maxlength="6" formControlName="sortCode" autocomplete="off"/>
                    @if (refundCreditsForm.get('sortCode')?.touched && refundCreditsForm.get('sortCode')?.invalid) {
                      <span class="glyphicon glyphicon-exclamation-sign form-control-feedback"></span>
                    }
                    @if (refundCreditsForm.get('sortCode')?.touched && refundCreditsForm.get('sortCode')?.invalid) {
                      <label id="sortCode-error" class="error help-block" for="sortCode">{{"financialDashboard.sortcodeerror" | cxTranslate}}</label>
                    }
                  </div>
                  <div class="col-xs-2 disableinputParent">
                    <label>{{"financialDashboard.country" | cxTranslate}}</label>
                    <label class="input_sublabel"></label>
                    <input type="text" name="country" class="form-control bankcountry" formControlName="country" readonly="true" value="GB"/>
                  </div>
                </div>
              </form>
              <div class="clearboth"></div>
              <div class="refund_btnConatiner col-xs-12">
                <button class="refundCancel_btn" (click)="cancelEditForm()">{{"financialDashboard.cancellabel" | cxTranslate}}</button>
                <button class="refundSave_btn" (click)="updateBankDetail()">{{"financialDashboard.savebankdetail" | cxTranslate}}</button>
              </div>
            </div>
          </div>
        }
        <!-- new bank details page ends -->
        <!-- confirm details page starts -->
        @if (bankdetailsavaiable && showConfirmBank) {
          <div class="col-xs-12 refund_confirmBankData">
            <div class="refund_editInnerDiv">
              <div class="refund_editHeader">
                <div class="refund_text1">{{"financialDashboard.bankdetails" | cxTranslate}}</div>
                <span class="refundEdit_btn" (click)="editBankDetails()">{{"financialDashboard.editlabel" | cxTranslate}}<div></div>
              </span>
            </div>
            <div class="refund_text2">{{"financialDashboard.confirmbankdetail" | cxTranslate}}</div>
            <div class="refund_dataWrapper col-xs-11">
              <div class="col-xs-12 border_box no-left-pad">
                <div class="inputParent col-xs-4">
                  <div class="refund_BankInfoHeader">{{"financialDashboard.accname" | cxTranslate}}</div>
                  <div class="refund_subBankinfo">{{"financialDashboard.fullbusinessname" | cxTranslate}}</div>
                  <!-- <div class="refund_BankInfoData staticbankname">{{financialresponse?.bankDetails?.bankName}}</div> -->
                  <div class="refund_BankInfoData staticbankname">{{refundCreditsForm.get('bankAccName')?.value}}</div>
                </div>
                <div class="inputParent col-xs-4">
                  <div class="refund_BankInfoHeader">{{"financialDashboard.bankaccno" | cxTranslate}}</div>
                  <div class="refund_subBankinfo"></div>
                  <!-- <div class="masked4 refund_BankInfoData staticbankacc" mask="****0000">{{financialresponse?.bankDetails?.payerbankAccountNumber}}</div> -->
                  <div class="masked4 refund_BankInfoData staticbankacc">{{applyAccNoMask(refundCreditsForm.get('bankAccNo')?.value)}}</div>
                </div>
                <div class="inputParent col-xs-2">
                  <div class="refund_BankInfoHeader">{{"financialDashboard.sortcode" | cxTranslate}}</div>
                  <div class="refund_subBankinfo"></div>
                  <!-- <div class="masked3 refund_BankInfoData staticbanksort" mask="****0000">{{financialresponse?.bankDetails?.payersortCode}}</div> -->
                  <div class="masked3 refund_BankInfoData staticbanksort">{{applySortCodeMask(refundCreditsForm.get('sortCode')?.value)}}</div>
                </div>
                <div class="inputParent col-xs-2">
                  <div class="refund_BankInfoHeader">{{"financialDashboard.country" | cxTranslate}}</div>
                  <div class="refund_subBankinfo"></div>
                  <div class="refund_BankInfoData staticbankcountry">{{refundCreditsForm.get('country')?.value}}</div>
                </div>
              </div>
              <div class="confirm_checkboxparent col-xs-12 no-left-pad">
                <label class="checkbox-button">
                  <input type="checkbox" name="checkbox" class="confirm_checkbox" [(ngModel)]="isChecked">
                  <span class="checkbox-button__control"></span>
                </label>
                <label class="checkboxtext">{{"financialDashboard.bankconfrmmsg" | cxTranslate}}</label>
              </div>
              <div class="clearboth"></div>
            </div>
          </div>
          <div class="col-xs-12 refund_tableBottomBtn">
            <div class="refund_totalAmountParent no-left-pad">{{"financialDashboard.refundamnt" | cxTranslate}} &nbsp;&nbsp;&nbsp; <span class="refund_totalAmount">{{financialresponse?.seqirusFinancialDashboardData?.credit.totalAvailableCredit | currency:'GBP':'symbol':'1.2-2'}}</span>
          </div>
          <div class="refund_rightBtnParent no-left-pad">
            <a class="refund_exitBtn" (click)="closeRefund()">{{"financialDashboard.exitlabel" | cxTranslate}}</a>
            <button type="submit" class="submitRefundBtn" [disabled]="!isChecked" (click)="submitRefund()">{{"financialDashboard.submitrefreq" | cxTranslate}}</button>
          </div>
        </div>
      </div>
    }
    <!-- confirm details page ends -->

    <div class="col-xs-12 credits_footnote2">{{ukCreditsContent.refundText}} <a [href]="getPdfUrl(ukCreditsContent.privacyLink)" target="_blank">privacy policy</a>.</div>
  </section>
}

<!-- Refund thank you starts -->
@if (showThankyouSection) {
  <section class="col-xs-12 col-sm-12 credits_UK credits_thankyou">
    <div class="refund_thankyouContainer">
      <div class="refund_thankyouHeader">{{"financialDashboard.refundthankyou" | cxTranslate}}</div>
      <div class="refund_thankyouPara">{{"financialDashboard.refundthankyoumsg" | cxTranslate}}</div>
      @if (showThankyouSection) {
        <button class="viewCredit" (click)="showProcessingCredits()">{{"financialDashboard.viewcreditstxt" | cxTranslate}}</button>
      }
    </div>
  </section>
}
<!-- Refund thank you ends -->
